<template>
  <div class="splash-container">
    <div class="top-item item">
      <v-progress-linear
        :indeterminate="true"
        color="green"
      />
    </div>
    <div class="main-item item">
      <img
        :src="scLogoImg"
        alt=""
        class="splash-loader"
      >
    </div>
  </div>
</template>

<script>
import scLogoImg from '@/../static/img/sc-logo.png';

export default {
  name: 'SplashScreen',

  data: () => ({
    scLogoImg,
  }),
}
</script>
